const ORDINALS = ['th', 'st', 'nd', 'rd']

const escapeSpecialChars = (string: string) =>
	string.replace(/[+\-&|!(){}[\]^"~*?:\\]/gm, char => `\\${char}`)

/*
* Use intl if you will need to support other locales
const ordinal = new Intl.PluralRules('en-US', { type: 'ordinal' })

const suff: Partial<Record<Intl.LDMLPluralRule, string>> = {
	few: 'rd',
	one: 'st',
	two: 'nd'
}
	const key = ordinal.select(asNumber)
	return `${asNumber}${suff[key] ?? 'th'}`
*/

function ordinalNumber(numberLike: unknown): number | string {
	const asNumber = Number(numberLike)

	if (Number.isNaN(asNumber)) {
		return asNumber
	}

	const v = asNumber % 100

	return asNumber + (ORDINALS[(v - 20) % 10] || ORDINALS[v] || ORDINALS[0])
}

const wrapExistProxy = <T extends Record<string, any>>(
	target: T,
	notExistKey = 'No value for key'
) =>
	new Proxy(Object.freeze(target), {
		get(target, prop) {
			if (prop in target) {
				return target[prop as keyof typeof target]
			}

			throw new Error(`${notExistKey}: ${prop.toString()}`)
		},

		set() {
			throw new Error('Read only object')
		}
	})

function subsetObject<O extends Record<string, any>, K extends keyof O>(
	obj: O,
	...keys: K[]
): Pick<O, K> {
	return keys.reduce(
		(acc, key) => {
			acc[key] = obj[key]

			return acc
		},
		{} as Pick<O, K>
	)
}

const roundToDecimal = (number: number) =>
	Math.round(number * 10 + Number.EPSILON) / 10

export {
	escapeSpecialChars,
	ordinalNumber,
	roundToDecimal,
	subsetObject,
	wrapExistProxy
}
